/**
 * ______                       ___  _____
 * | ___ \                     |_  |/  ___|
 * | |_/ /__ _   __ _   ___      | |\ `--.
 * |  __// _` | / _` | / _ \     | | `--. \
 * | |  | (_| || (_| ||  __/ /\__/ //\__/ /
 * \_|   \__,_| \__, | \___| \____/ \____/
 *               __/ |
 *              |___/
 *
 */

// Encoding: UTF-8
$(document).ready(function() {
	/********************************************/
	/*				Externe Links	 			*/
	/********************************************/
	// Für Target_blank HTML-konform
	$("area.external, a[rel=external]").attr("target", "_blank");
	$("a[rel=top]").attr("target", "_top");
	$("a[rel=self]").attr("target", "_self");
	// Overlay Menü INIT 1 = Haupt 2 = Sticky
	init_menu_overlay(1);
	init_menu_overlay(2);
	// Sticky Navi
	init_sticky_navi();
	if (typeof request_typeahead_string !== 'undefined' && typeof active_page_id !== 'undefined' && typeof typeahead_language !== 'undefined') {
		load_typeahead(request_typeahead_string,active_page_id,typeahead_language);
	}
	// Init lazy loading of images
	init_images();
	// Newsletter anmeldung: Cached selection removing and other functions
	newsletter_clear_radio_field();
	// Für Einzelbestellung Formular
	$("#digitale-ausgabe-klick").click(function(){
		if ( $("#digitale_ausgabe").is(":checked") ) {
			if ( $("#print_ausgabe").is(":checked") ) {
				$("#lieferadresse-block").show();
				if ($("#lieferadresse-verwenden-ja").is(":checked")) {
					$("#wako-form-lieferadresse").show();
				}
			} else {
				$("#lieferadresse-block").hide();
				$("#wako-form-lieferadresse").hide();
			}
		} else {
			$("#lieferadresse-block").show();
			if ($("#lieferadresse-verwenden-ja").is(":checked")) {
				$("#wako-form-lieferadresse").show();
			}
		}
	});
	$("#print-ausgabe-klick").click(function(){
		if ( $("#print_ausgabe").is(":checked") ) {
			$("#lieferadresse-block").show();
			if ($("#lieferadresse-verwenden-ja").is(":checked")) {
				$("#wako-form-lieferadresse").show();
			}
		} else {
			$("#lieferadresse-block").hide();
			if ($("#lieferadresse-verwenden-ja").is(":checked")) {
				$("#wako-form-lieferadresse").hide();
			}
		}
	});
	if ($('#change-cookie-settings').length > 0) {
		document.getElementById("change-cookie-settings").addEventListener('click',function (e) {
		 	e.preventDefault();
			cookiemanager.show_dialog();
		});
	}
	// Zeitschriften Formulare (Verändern bei KLICK)
	$("[name='abo_typ_id']").click(function(){
		var abo_typ_id			= $(this).val();
		var praemie_vorhanden	= $("#praemie_vorhanden_" + abo_typ_id).val();
		var unter_abo_vorhanden = $("#unterabo_vorhanden_" + abo_typ_id).val();
		var geschenk_abos		= $("#geschenk_abo_ids").val();
		var geschenk_array 		= JSON.parse("[" + geschenk_abos + "]");
		var geschenk_abo		= checkArray(geschenk_array,abo_typ_id)
		// Slide Down gesamter Formular Inhalt
		$(".formular-content").show();
		$('html,body').animate({scrollTop:$("#formular").offset().top},2000);
		// Alle Infos zu Prämien und Zusatz Infos hiden
		$(".praemien-titel").hide();
		$(".zusatz_abo").hide();
		// Nur die Prämien und Zusatz Infos zeigen die auch für den Abo Typ da sind
		$("#praemien_titel_" + abo_typ_id).show();
		$("#unter_abo_" + abo_typ_id).show();
		if (praemie_vorhanden >= 1) {
			$("#praemie-content").show();
		} else {
			$("#praemie-content").hide();
		}
		if (unter_abo_vorhanden >= 1) {
			$("#unterabo-content").show();
		} else {
			$("#unterabo-content").hide();
		}
		if (geschenk_abo == true) {
			$("#verschenk-header").show();
			$("#lieferadresse-header").hide();
			$("#wako-form-geschenkadresse").show();
			$("#wako-form-lieferadresse").hide();
		} else {
			$("#lieferadresse-header").show();
			$("#verschenk-header ").hide();
			$("#wako-form-geschenkadresse").hide();
			if ($("input[type=radio][name=rechnungsadresse_ist_lieferadresse]").val() == 1) {
				$("#wako-form-lieferadresse").hide();
			} else {
				$("#wako-form-lieferadresse").show();
			}
		}
	});
	$( "div.werksausgabe-button" ).mouseenter(function() {
		var werks_id	= $(this).attr('id').replace("box-","");
		$("#overlay-" + werks_id).show();
	}).mouseleave(function() {
		var werks_id	= $(this).attr('id').replace("box-","");
		setTimeout(function() {
			$("#overlay-" + werks_id).hide();
		}, 200);
	});

	// boev_banner_toggle init
	boev_handler();

	$(".gpsr-header").click(function(){
		if($(this).html().indexOf('down') != -1){
			$(this).html($(this).html().replace('fa-chevron-down', 'fa-chevron-up'));
		} else {
			$(this).html($(this).html().replace('fa-chevron-up', 'fa-chevron-down'));
		}
		$(".gpsr-body").slideToggle(100);
	});
});

/**
 * lazy-loading
 * */
function init_images() {
	// Lazy loading of images using jquery.unveil
	// Exceptions:
	//	- whcaptcha
	// $(":not(.whcaptcha)").unveil(20);
}

/** show main menu overlays with a delay **/
function init_menu_overlay(type) {
	if (type == 1) {
		var overlays 			= '.header-navigation-overlay';
		var navigation_menue 	= '.header-navigation-menu';
		var data				= 'overlay';
		var overlay_menue		= '#header_navigation_overlay_';
	} else {
		var overlays 			= ".sticky-header-navigation-overlay";
		var navigation_menue 	= '.sticky-header-navigation-menu';
		var data				= 'sticky-overlay';
		var overlay_menue		= '#sticky_header_navigation_overlay_';
	}
	var id 						= 0;
	var menu_overlay_mouseover 	= false;
	$(navigation_menue).on("mouseover", function(){
		id = $(this).data(data);
		$(overlays).css("display", "none");
		$(overlay_menue + id).css("display","block");
		menu_overlay_mouseover = true;
	}).on("mouseleave", function(){
		menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!menu_overlay_mouseover) {
				$(overlay_menue + id).css("display","none");
			}
		}, 500);
	});
	$(overlays).on("mouseover", function(){
		$(this).css("display", "block");
		menu_overlay_mouseover = true;
	}).on("mouseleave", function(){
		menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!menu_overlay_mouseover) {
				$(overlays).css("display", "none");
			}
		}, 500);
	});
}

function init_sticky_navi() {
	var a = $("#header").height();
	a += $("#header_main_navigation").height();
	$(window).bind("scroll", function() {
		if ($(window).scrollTop() > a) {
			$("#sticky_main_navigation").addClass("d-lg-block");
			$(".totop").show();
		} else {
			$("#sticky_main_navigation").removeClass("d-lg-block");
			$(".totop").hide();
		}
	});
	// Slowly scrolling to the top of the page
	$(".totop").click(function(e){
		$("html, body").animate({
			scrollTop: $("#header").offset().top
		},"slow");
		e.preventDefault();
	});
}

function insert_to_merkzettel(artikeL_id,artikel_typ) {
	$.ajax ({
		type: 'GET'
		,url: '/ajax/insert_into_merkzettel'
		,data: 'artikel_id=' + artikeL_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success',xml).text() == 'true') {
				$('#merkzettel-counter-nav').html($('counter',xml).text());
				$('#merkzettel-erfolg-' + artikeL_id).html($('feedback_text',xml).text());
				$('#merkzettel-erfolg-' + artikeL_id).slideDown('slow');
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Artikel konnte nicht auf den Merkzettel gesetzt werden.");
		}
	});
}

function delete_from_merkzettel(artikeL_id) {
	$.ajax ({
		type: 'GET'
		,url: '/ajax/delete_from_merkzettel'
		,data: 'artikel_id=' + artikeL_id
		,cache: false
		,success: function(html) {
			$('#ajax-content-merkzettel').html(html);
			var m_counter = $('#m-counter').val();
			$('#merkzettel-counter-nav').html(m_counter);
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Artikel konnte nicht vom Merkzettel gelöscht werden.");
		}
	});
}

function close_merkzettel_info(artikel_id) {
	var artikel_id = artikel_id;
	$('#merkzettel-erfolg-' + artikeL_id).slideUp('slow');
}

function toggle_pressestimme() {
	if ($("#pressestimme-content").is(":visible") == 1) {
		$("#pressestimme-content").hide();
		$(".p-link-aufklappen").show();
		$(".p-link-zuklappen").hide();
	} else {
		$("#pressestimme-content").show();
		$(".p-link-zuklappen").show();
		$(".p-link-aufklappen").hide();
	}
}

function toggle_leserstimmen() {
	if ($("#leserstimmen-content").is(":visible") == 1) {
		$("#leserstimmen-content").hide();
		$(".l-link-aufklappen").show();
		$(".l-link-zuklappen").hide();
	} else {
		$("#leserstimmen-content").show();
		$(".l-link-zuklappen").show();
		$(".l-link-aufklappen").hide();
	}
}

function show_leserstimmen_formular() {
	if ($("#leserstimmen-formular").is(":visible") == 1) {
		$("#leserstimmen-formular").hide();
	} else {
		$("#leserstimmen-formular").show();
	}
}

function decryptThis(s) {
	var n=0;
	var r="";
	for(var i=0;i<s.length;i++) {
		n=s.charCodeAt(i);
		if (n>=8364) {n = 128;}
		r += String.fromCharCode(n-(2));
	}
	return r;
}

function decrypt_mail(element, email, params) {
	if (!params) var params = '';
	element.href = 'mailto:' + decryptThis(email) + params;
}

function add_param_to_url(url,name,value) {
	var re = new RegExp("([?&]" + name + "=)[^&]+", "");

	function add(sep) {
		url += sep + name + "=" + encodeURIComponent(value);
	}

	function change() {
		url = url.replace(re, "$1" + encodeURIComponent(value));
	}

	if (url.indexOf("?") === -1) {
		add("?");
	} else {
		if (re.test(url)) {
			change();
		} else {
			add("&");
		}
	}
	return url;
}

function removeURLParameter(url, parameter) {
	//prefer to use l.search if you have a location/link object
	var urlparts= url.split('?');
	if (urlparts.length>=2) {

		var prefix= encodeURIComponent(parameter)+'=';
		var pars= urlparts[1].split(/[&;]/g);

		//reverse iteration as may be destructive
		for (var i= pars.length; i-- > 0;) {
			//idiom for string.startsWith
			if (pars[i].lastIndexOf(prefix, 0) !== -1) {
				pars.splice(i, 1);
			}
		}
		url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
		return url;
	} else {
		return url;
	}
}

// Mit Ajax aktuellen Menü Click in Session speichern
function get_menu_root_id(menue_root_id) {
	$.ajax ({
		type: 'GET',
		url: '/ajax/set_navigation_id',
		data: 'nav_id=' + menue_root_id,
		cache: false
	});
}

// Menü aktiv setzen
function set_menu_aktiv(menue_root_id) {
	$("#header_menu_" + menue_root_id).addClass('aktiv');
	$("#sticky_header_menu_" + menue_root_id).addClass('aktiv');
}


// Sidebar INIT
function init_sidebar() {
	if ($("#page").css("position") == "fixed") {
		close_sidebar();
	} else {
		$("#page").css("position", "fixed");
		$("#page").css("transform", "translate3d(-300px,0,0)");
		$("#sidebar").css("transform", "translate3d(0px,0,0)");
		$("#sidebar").css("display", "block");
	}
}

// Sidebar CLOSE
function close_sidebar() {
	$("#page").css("position", "relative");
	$("#page").css("transform", "translate3d(0px,0,0)");
	$("#sidebar").css("transform", "translate3d(-300px,0,0)");
	$("#sidebar").css("display", "none");
}


function toggle_search() {
	if ($("#mobile_search_input_box").is(":visible") == 0) {
		$("#mobile_search_input_box").slideDown("slow");
	} else {
		$("#mobile_search_input_box").slideUp("slow");
	}
}

function checkArray(array,obj) {
	for(var i = 0; i < array.length; i++) {
		if (array[i] == obj) {
			return true;
		}
	}
	return false;
}

function show_partnerinfos() {
	if ($("#info-text").is(":visible") == 0) {
		$("#info-text").slideDown("slow");
	} else {
		$("#info-text").slideUp("slow");
	}
}

function toogle_code_form(id) {
	if ($("#formular-" + id).is(":visible") == 0) {
		$("#formular-" + id).show();
	} else {
		$("#formular-" + id).hide();
	}
}

function newsletter_clear_radio_field() {
	var newsletter_field = $("input[name=select_newsletter_type]:checked");

	if (newsletter_field.length > 0) {
		newsletter_field.attr('checked', false);
	}

	// Init selection function
	newsletter_select_newsletter_type();
}

function newsletter_select_newsletter_type(newsletter_field) {
	$("input[name=select_newsletter_type]").on('click', function() {
		var _this = $(this);
		var spinner = $("#newsletter .loader");
		var value = _this.val();

		// show spinner
		spinner.show();

		if (value != undefined && value > 0 && value < 4) {
			$("#newsletter .newsletter-container").slideUp(50);
			$.ajax({
				url:		"/ajax/newsletter",
				type:		"POST",
				data:		{
					val:	value
				},
				dataType:	"html",
				success:	function(data) {
					$("#newsletter .newsletter-container").html(data);
					spinner.delay(100).hide();
					$("#newsletter .newsletter-container").delay(100).slideDown(100);
				},
				error:		function(data) {
					alert("There went something wrong while loading");
					spinner.delay(100).hide();
					$("#newsletter .newsletter-container").delay(100).slideDown(100);
				}
			});
		}
	});
}

// hide boev banner if there is no space
function boev_handler() {
	// initial check
	boev_banner();
	// on resize
	$(window).on('resize', function(){
		boev_banner();
	});
}
function boev_banner() {
	// addition of the menu width
	var menu_width				= 0;
	var sticky_menu_width		= 0;
	var menu_container_width	= $("#header_main_navigation div.main-navi-container").width();
	var boev_logo_width			= 134;
	var _menu					= $("#header_main_navigation ul.main-navi");
	var _boev					= $("#boev-banner");
	var _boev_sticky			= $("#boev-banner-sticky");

	// loop trough menu items and add width of menu
	_menu.find('li:not(#boev-banner)').each(function() {
		_mitem				= $(this);
		w					= _mitem.width();
		menu_width			+= w;
		sticky_menu_width	+= w;
	});

	// add width to sticky navi (bigger home button)
	sticky_menu_width		+= 14;

	// check if boev banner should be displayed
	if (menu_container_width > menu_width && (menu_container_width - menu_width) >= boev_logo_width) {
		// remove hidden class
		_boev.removeClass('d-none');
	} else {
		// add hidden class
		_boev.addClass('d-none');
	}

	// check if boev banner should be displayed (sticky)
	if (menu_container_width > sticky_menu_width && (menu_container_width - sticky_menu_width) >= boev_logo_width) {
		// remove hidden class
		_boev_sticky.removeClass('d-none');
	} else {
		// add hidden class
		_boev_sticky.addClass('d-none');
	}
}

function show_video(video_url,height,width,bytes,thumb_id,widget_id,widget_breite) {
	var box 			= document.querySelector('#' + thumb_id);
	var box_width 		= box.offsetWidth;
	var box_height 		= box.offsetHeight;
	var screen_width 	= screen.width;
	var inner_width 	= window.innerWidth;
	$.ajax({
		type: "POST",
		url: '/ajax/show_video',
		data: {
			video_url		: video_url,
			height			: height,
			width 			: width,
			bytes			: bytes,
			thumb_id		: thumb_id,
			widget_id 		: widget_id,
			screen_width	: screen_width,
			inner_width		: inner_width,
			widget_breite	: widget_breite
		},
		success: function(html,textStatus){
			$("#" + thumb_id).hide();
			$("#video-container-" + widget_id).html(html);
		},
		error: function(){
			alert("Beim Laden des Videos ist ein Fehler aufgetreten.");
		}
	});

}